import { FC } from "react";
import { ContentContainerProps } from "./types";

const ContentContainer: FC<ContentContainerProps> = ({ children }) => {
  return (
    <div className="grid grid-cols-2 items-center justify-center overflow-hidden">
      {children}
    </div>
  );
};

export default ContentContainer;
